module.exports = __webpack_public_path__ + "img/icon70.fbd5ef3e.png";